import React, { useEffect, useRef } from 'react';
import { IoChevronUp } from 'react-icons/io5';
import { HashLink as Link } from 'react-router-hash-link';

const ScrollToTop = ({ width, height, maxWidth }) => {
  const reference = useRef(null);

  useEffect(() => {
    const checkScroll = () => {
      if (reference && reference.current) {
        if (window.pageYOffset > 1000) {
          
          reference.current.classList.remove('fade-out');
          reference.current.classList.add('fade-in');
        } else {
          reference.current.classList.remove('fade-in');
          reference.current.classList.add('fade-out');
        }
      }
    }
    window.addEventListener('scroll', checkScroll);
    checkScroll();
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  return (
    <Link
      ref={reference}
      className="fade-able"
      to="#top"
      smooth
      style={{
        width: 80,
        height: 80,
        borderRadius: 40,
        color: 'white',
        backgroundColor: '#F1C825',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: 18,
        fontFamily: 'Montserrat Bold',
        letterSpacing: 1.8,
        position: 'fixed',
        top: height - 140,
        left: width - 132,
        zIndex: 20
      }}
    >
      <IoChevronUp fontSize={50} fontWeight="300" style={{ fontWeight: 'lighter', lineHeight: 1, paddingBottom: 0, marginBottom: 0, marginTop: -12 }} />
      <div style={{ marginTop: -12}}>
      TOP
      </div>
    
    </Link>
  )
}

export default ScrollToTop;
